import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';

import authServices from '@/auth/main/DependencyInjection';
import { createApolloAuthLink } from '@/auth/infrastructure/ApolloAuthLink';
import { createApolloErrorLink } from '@/auth/infrastructure/ApolloErrorLink';
import introspectionResult from '../generated/introspection.json';

// Generated by codegen

// Extract possible types from introspection result
const possibleTypes = introspectionResult.__schema.types.reduce(
  (acc, type) => {
    if (type.possibleTypes) {
      acc[type.name] = type.possibleTypes.map((subtype: any) => subtype.name);
    }
    return acc;
  },
  {} as Record<string, string[]>,
);

const cache = new InMemoryCache({ possibleTypes });

const graphqlEndpoint = import.meta.env?.VITE_GRAPHQL_URL || '';
const queryVersion = '/v2';

// HTTP link for connecting to the GraphQL server
const httpLink = createHttpLink({
  uri: `${graphqlEndpoint}${queryVersion ?? ''}`,
});

// Get token service from auth module
const { tokenService } = authServices;

// Create auth link using the token service
const authLink = createApolloAuthLink(tokenService);

// Create error link for handling GraphQL errors, including auth errors
const errorLink = createApolloErrorLink();

// Create Apollo Client with Auth Middleware and Error Handling
// Order matters: errorLink should be before httpLink to catch any GraphQL errors
// The flow is: errorLink -> authLink -> httpLink
const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache,
  connectToDevTools: process.env.NODE_ENV !== 'production',
  defaultOptions: { query: { fetchPolicy: 'cache-first' } },
});

export default client;
